<header class="navbar navbar-default navbar-fixed-top" id="header-navbar">
    <nav class="header-nav">
        <!-- Logo and notification -->
        <div class="logo-and-notification-container">
            <!-- logo -->
            <span id="logo" class="navbar-brand">
                <img alt="" class="normal-logo logo-white"
                    src="assets/app-content/img/logo-old.png">
                <img alt="" class="normal-logo logo-black"
                    src="assets/app-content/img/logo-black.png">
                <img alt="" class="small-logo hidden-xs hidden-sm hidden"
                    src="assets/app-content/img/logo-small.png">
            </span>
        </div>
        <!-- Company name -->
        <span class="label label-primary header-company-name">
            <span *ngIf="userDetails.company.companyId === null">(New Company)</span>
            <span title={{userDetails.company.companyName}} *ngIf="(userDetails.company.companyId !== null)">
                {{userDetails.company.companyName | companyNameFilterPipe}}
            </span>
        </span>

        <!-- profile and logout -->
        <div class="nav-no-collapse pull-right col-sm-4 header-profile-and-logout-container" id="header-nav">
            <ul class="nav navbar-nav" style="display:flex; flex-wrap: nowrap">
                <li class="profile-dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" style="cursor:default"> 
                        <img src="assets/samples/4dot5-default-no-profile-pic.jpg"> 
                        <span class="hidden-xs hidden-sm"
                            title="{{(userDetails.lastname !== null) ? (userDetails.firstname + ' ' + userDetails.lastname) : (userDetails.firstname)}}"
                            [textContent]="((userDetails.lastname !== null) ? (userDetails.firstname + ' ' + userDetails.lastname) : (userDetails.firstname)) | profileFilterPipe"></span>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</header>